import script from "./Author.vue?vue&type=script&setup=true&lang=js"
export * from "./Author.vue?vue&type=script&setup=true&lang=js"

import "./Author.vue?vue&type=style&index=0&id=1b348711&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b348711"]])

export default __exports__